import React from 'react';
import { useLocation } from "react-router-dom";
import { key, cx} from '../API/GoogleSearchApi'
import ShowGoogleSearch from './ShowGoogleSearch';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
// import { useNavigate} from 'react-router-dom';


const SearchResults = () => {
    const location = useLocation();  

    const [state, setState] = React.useState(location.state ? location.state: "");
    // state for hold our results from api
     const [results, setResults] = React.useState([]);
     const [info, setInfo] = React.useState('');

            // use effect initially empty array
    // state for hold our results from api

    const searchGoogle = async (e) => {
        // const navigate = useNavigate();
        e.preventDefault()
        console.log(state,"State");
        try {
            fetch(
                `https://www.googleapis.com/customsearch/v1?key=${key}&cx=${cx}&q=${state}`
            )
            .then(response => response.json())
            .then(
                data => {
                // console.log(data.items)
                setResults(data.items);
                setInfo(data.searchInformation);
                }
            );
            


            
        } catch (error) {
            console.log("No Data Fount");
            // navigate("/404");
        }
       
    };
    console.log(results, "Result");
    console.log(info, "info");

    // useeffect send request data from search bar to search result page to show data without click again on button
        // after redirect to next page it show rquest result from parent page

        React.useEffect(() =>{
        async function getResult(){
            // const navigate = useNavigate();
                if(location.state){
                    try {
                        fetch(
                            `https://www.googleapis.com/customsearch/v1?key=${key}&cx=${cx}&q=${state}`
                        )
                        .then(response => response.json())
                        .then(
                            data => {
                            // console.log(data.items)
                            setResults(data.items);
                            setInfo(data.searchInformation);
                            }
                        );
                        
            
            
                        
                    } catch (error) {
                        // navigate("/404");
                        console.log("No Data Fount");
                    }
                }
            }
            getResult();
        },[]) 
        // after redirect to next page it show rquest result from parent page
    // [] empty array help to refresh our component again again 
    // useeffect send request data from search bar to search result page to show data without click again on button
    return (
        <div className='container results-found'>
            {/* testing State Props for data calling from parent component */}
                     {/* <div>{location.state}</div> */}
            {/* testing State Props for data calling from parent component */}
            <h1 class="info-large">Search</h1>
            <Form className="search-bar-header mb-5" onSubmit={searchGoogle}>
                <InputGroup>
                    <Form.Control
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="search-nav"
                        onChange={(e) => setState(e.target.value)} 
                        value={state}/>
                        
                    <Button variant="" id="search-nav">
                    <img src='assets/img/search-icon.svg' alt=""/> 
                    </Button>
                </InputGroup>
            </Form>    
            
            <h1 class="results-title">Search Results</h1>
            <ShowGoogleSearch results={results} info={info}/>

        </div>
    );
};

export default SearchResults;